import React,{ useState, useEffect} from 'react';
import { NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';


const NewAddress = ({onSubmit, initAddress, noAddInfo, btnText}) => {

    const [newAddress, setNewAddress] = useState({});

    const [checkFields, setCheckFields] = useState({});

    //const inputFields = ['postalCode', 'city', 'streetName', 'streetNumber', 'apartmentBuilding', 'entrance', 'floor', 'apartment'];
    const inputFields = ['postalCode', 'city', 'streetName', 'streetNumber'];
    const errorMsg    = "Полето е задължително";

    useEffect(()=>{
        setNewAddress({
            postalCode        : initAddress?.postalCode        || null,        city: initAddress?.city         || null, 
            streetName        : initAddress?.streetName        || null,streetNumber: initAddress?.streetNumber || null, 
            apartmentBuilding : initAddress?.apartmentBuilding || null,    entrance: initAddress?.entrance     || null, 
            floor             : initAddress?.floor             || null,   apartment: initAddress?.apartment    || null 
        });
        setCheckFields({});
    }, [initAddress])

    const onChangeHandler = (field, data) =>  {
        setNewAddress({...newAddress, [field]: data});
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForLatin = (fieldValue) => {
        if (!fieldValue) return;
        return fieldValue.match(/[a-zA-Z]/) ? true : false;
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = newAddress[field] ? checkForLatin(newAddress[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !newAddress[field]);
            case 'zip':
                return (checkFields[field] || allFields) && (!newAddress[field] || (newAddress[field]?.length < 4));
            default:
                return (checkFields[field] || allFields) && !newAddress[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${newAddress[field] ? 'на кирилица' : ''}`;
            case 'latin':
                return `${errorMsg} ${newAddress[field] ? 'на латиница' : ''}`;
            case 'zip':
                return `${errorMsg} ${newAddress[field] ? '4 символа' : ''}`;
            default:
                return errorMsg;
        }
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field === 'postalCode') {
                if(checkForError(field, 'zip', true)) return false;
            } else {
                if(checkForError(field, null, true)) return false;
            }
        }

        return true;
    }

    const submitHandler = async () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields()) {
            onSubmit(newAddress);
            setNewAddress({});
            setCheckFields({})
        }
    }

    return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div className="address-container-one" style={{marginBottom: '20px'}}>
                <NuInsInputNumLabel onChange={(data)=>onChangeHandler('postalCode', data)} onBlur={()=>onBlurHandler('postalCode')}
                                    validationType={"noZero"} slice={4} 
                                    placeholder={"Пощенски код"} 
                                    value={newAddress['postalCode']}                                
                                    error={checkForError('postalCode', 'zip')} 
                                    errorMsg={generateErrorMsg('postalCode', 'zip')}/>
                </div>
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('city', data)} onBlur={()=>onBlurHandler('city')}
                                    placeholder={"Град"} 
                                    value={newAddress['city']}                                
                                    error={checkForError('city', 'cyrilic')} 
                                    errorMsg={generateErrorMsg('city', 'cyrilic')}
                                    styles={{marginBottom: '20px'}}/>
               
                <div className="address-container-three" style={{marginBottom: '20px'}}>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetName', data)} onBlur={()=>onBlurHandler('streetName')}
                                        placeholder={"ж.к. / кв. / ул. "} 
                                        value={newAddress['streetName']}                                
                                        error={checkForError('streetName', 'cyrilic')} 
                                        errorMsg={generateErrorMsg('streetName', 'cyrilic')}/>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetNumber', data)} onBlur={()=>onBlurHandler('streetNumber')}
                                        placeholder={"№"} 
                                        value={newAddress['streetNumber']}                                
                                        error={checkForError('streetNumber')} 
                                        errorMsg={generateErrorMsg('streetNumber')}/>
                    
                </div>
                <div className="address-container-two" style={{marginBottom: '20px'}}>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartmentBuilding', data)} onBlur={()=>onBlurHandler('apartmentBuilding')}
                                        placeholder={"Блок"} 
                                        value={newAddress['apartmentBuilding']}                                
                                        /* error={checkForError('apartmentBuilding')} 
                                        errorMsg={generateErrorMsg('apartmentBuilding')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('entrance', data)} onBlur={()=>onBlurHandler('entrance')}
                                        placeholder={"Вход"} 
                                        value={newAddress['entrance']}                                
                                        /* error={checkForError('entrance')} 
                                        errorMsg={generateErrorMsg('entrance')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('floor', data)} onBlur={()=>onBlurHandler('floor')}
                                        placeholder={"Етаж"} 
                                        value={newAddress['floor']}                                
                                        /* error={checkForError('floor')} 
                                        errorMsg={generateErrorMsg('floor')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartment', data)} onBlur={()=>onBlurHandler('apartment')}
                                        placeholder={"Ап."} 
                                        value={newAddress['apartment']}                                
                                       /*  error={checkForError('apartment')} 
                                        errorMsg={generateErrorMsg('apartment')} */
                                        />
                </div>
                {!noAddInfo && <>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('addInfo', data)}
                                            placeholder={"Допълнителна информация за адреса"} 
                                            value={newAddress['addInfo']}
                                            />
                    </>
                }

                <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" style={{alignSelf: 'center'}} onClick={submitHandler}>
                   {btnText ? btnText : 'Добави'} 
                </button>
            </div>
    )
}

export default NewAddress;